import React, {ReactNode} from 'react';
import {connect} from 'react-redux';
import {FormName, getFormValues} from 'redux-form';
import get from 'lodash/get';

interface ChildrenFunctionParams {
    formData: any;
    scopedFormData?: any;
    getSource?: (source: string) => string;
}

interface ConnectedProps {
    children: (params: ChildrenFunctionParams) => ReactNode;
    record?: any;
    source?: string;

    [key: string]: any;
}

interface ConnectedFormProps extends ConnectedProps {
    form: string;
}

interface Props extends ConnectedFormProps {
    formData: any;
    index?: number;
}

/**
 * Get the current (edited) value of the record from the form and pass it
 * to child function
 *
 * @example
 *
 * const PostEdit = (props) => (
 *     <Edit {...props}>
 *         <SimpleForm>
 *             <BooleanInput source="hasEmail" />
 *             <FormDataConsumer>
 *                 {({ formData, ...rest }) => formData.hasEmail &&
 *                      <TextInput source="email" {...rest} />
 *                 }
 *             </FormDataConsumer>
 *         </SimpleForm>
 *     </Edit>
 * );
 *
 * @example
 *
 * const OrderEdit = (props) => (
 *     <Edit {...props}>
 *         <SimpleForm>
 *             <SelectInput source="country" choices={countries} />
 *             <FormDataConsumer>
 *                 {({ formData, ...rest }) =>
 *                      <SelectInput
 *                          source="city"
 *                          choices={getCitiesFor(formData.country)}
 *                          {...rest}
 *                      />
 *                 }
 *             </FormDataConsumer>
 *         </SimpleForm>
 *     </Edit>
 * );
 */
// @ts-ignore
export const FormDataConsumerView: React.FunctionComponent<Props> = ({
                                                                         children,
                                                                         form,
                                                                         formData,
                                                                         source,
                                                                         index,
                                                                         dispatch,
                                                                         ...rest
                                                                     }: Props) => {
    let scopedFormData = formData;
    let getSource;
    let getSourceHasBeenCalled = false;
    let ret;

    // If we have an index, we are in an iterator like component (such as the SimpleFormIterator)
    if (typeof index !== 'undefined') {
        // @ts-ignore
        scopedFormData = get(formData, source);
        getSource = (scopedSource: string) => {
            getSourceHasBeenCalled = true;
            return `${source}.${scopedSource}`;
        };
        ret = children({formData, scopedFormData, getSource, ...rest});
    } else {
        ret = children({formData, ...rest});
    }

    console.warn(
        typeof index !== 'undefined' && ret && !getSourceHasBeenCalled,
        'You\'re using a FormDataConsumer inside an ArrayInput and you did not called the getSource function supplied by ' +
        'the FormDataConsumer component. This is required for your inputs to get the proper source.'
    );

    return ret === undefined ? null : ret;
};

const mapStateToProps = (
    state: object,
    {form, record}: ConnectedFormProps
) => ({
    formData: getFormValues(form)(state) || record,
});

const ConnectedFormDataConsumerView = connect(mapStateToProps)(
    FormDataConsumerView
);

const FormDataConsumer = (props: ConnectedProps) => (
    <FormName>
        {({form}) => <ConnectedFormDataConsumerView form={form} {...props} />}
    </FormName>
);

export default FormDataConsumer;